<template>
  <b-modal
    v-model="value"
    hide-footer
    no-close-on-esc
    @hide="$emit('input', false)"
  >
    <template #modal-header="{ hide }">
      <h5 class="modal-title mr-auto">
        {{ title }}
      </h5>
      <button
        class="btn btn-white btn-sm mr-1"
        @click.prevent="$refs['notes'].createNote()"
      >
        <i class="fa fa-sticky-note-o mr-1"></i>
        Add Note
      </button>
      <button
        class="btn btn-sm btn-white"
        @click.prevent="hide()"
      >
        Close
      </button>
    </template>
    <slot></slot>
    <notes
      ref="notes"
      :annotatable-type="annotatableType"
      :annotatable-id="annotatableId"
    ></notes>
  </b-modal>
</template>

<script>
import Notes from '@/components/Notes'

export default {
  components: {
    Notes
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Notes'
    },
    annotatableType: {
      type: String,
      required: true
    },
    annotatableId: {
      type: [String, Number],
      required: true
    },
  }
}
</script>